export default __webpack_public_path__ + "static/media/1.fb03cb68.png";